import InventoryActions from './InventoryActions';

export default {
  [InventoryActions.ADD]: 'plus-circle',
  [InventoryActions.REMOVE]: 'minus-circle',
  [InventoryActions.MOVE]: 'bus',
  [InventoryActions.DONATED]: 'people-group',
  [InventoryActions.DONATION_RECEIVED]: 'shopping-bag',
  [InventoryActions.DONATION_REMOVED]: 'shopping-bag',
  [InventoryActions.INCOMING_ORDER]: 'cart-plus',
  [InventoryActions.OUTGOING_ORDER]: 'shopping-cart',
  [InventoryActions.SCHEDULE]: 'calendar-check-o',
  [InventoryActions.ORDER_SHIPPED]: 'plane',
  [InventoryActions.ORDER_RECEIVED]: 'truck',
  [InventoryActions.DAMAGED]: 'ban',
  [InventoryActions.SPOILED]: 'ban',
  [InventoryActions.EXPIRED]: 'ban',
  [InventoryActions.LOST]: 'question',
  [InventoryActions.STOLEN]: 'question',
  [InventoryActions.VISIT]: 'street-view',
  [InventoryActions.ADD_CORRECTION]: 'check',
  [InventoryActions.PURCHASED]: 'shopping-cart',
  [InventoryActions.DISTRIBUTION_RECEIVED]: 'sitemap',
  [InventoryActions.REMOVE_CORRECTION]: 'check',
  [InventoryActions.DONATED]: 'shopping-bag',
  [InventoryActions.SOLD]: 'shopping-cart',
  [InventoryActions.DISTRIBUTED]: 'sitemap'
};
